import { useNavigate } from "react-router-dom";
import {
  encodeCaseNumberForPath,
  normalizeCaseNumbers,
} from "../../utils/caseNumber";

const ReportHit = ({ hit, authState, signIn, openPDFWithPreSignedUrl, pdfLoading }) => {
  const navigate = useNavigate();

  if (!hit || !hit.nameofparties || !hit.standard_casenumber) {
    return null;
  }

  const caseNumbers = normalizeCaseNumbers(hit.standard_casenumber);
  const primaryCaseNumber = caseNumbers[0] || hit.standard_casenumber;
  const caseNumberLabel = caseNumbers.join(", ") || hit.standard_casenumber;
  const summaryPath = primaryCaseNumber
    ? `/summary/${encodeCaseNumberForPath(primaryCaseNumber)}`
    : null;

  const handleViewJudgment = (event) => {
    if (!authState.isAuthenticated) {
      event.preventDefault();
      sessionStorage.setItem("redirectToDocument", hit.link);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "login prompt",
        event_category: "User",
        event_label: "Login Redirect",
        value: "redirectToDocument",
      });

      const urlString = window.location.search;
      if (urlString) {
        sessionStorage.setItem("urlString", urlString);
      }

      const currentPath = window.location.pathname;
      sessionStorage.setItem("redirectAfterLogin", currentPath);

      signIn();
      return;
    }

    openPDFWithPreSignedUrl(hit.link);
  };

  const handleViewSummary = () => {
    if (!summaryPath) {
      return;
    }

    sessionStorage.setItem(
      "summaryBackPath",
      JSON.stringify({
        summaryPath,
        backPath: `${window.location.pathname}${window.location.search}`,
      })
    );

    if (!authState.isAuthenticated) {
      sessionStorage.removeItem("redirectToDocument");
      sessionStorage.removeItem("urlString");
      sessionStorage.setItem("redirectAfterLogin", summaryPath);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "login prompt",
        event_category: "User",
        event_label: "Login Redirect",
        value: "redirectToSummary",
      });

      signIn();
      return;
    }

    navigate(summaryPath);
  };

  return (
    <tr className="border-b border-pl-border transition hover:bg-pl-bg-subtle">
      <td className="py-2 md:py-3 px-2 align-top w-[88px] md:w-[170px]">
        <button
          type="button"
          onClick={handleViewJudgment}
          disabled={pdfLoading}
          className={`bg-transparent p-0 border-0 text-left text-14 md:text-15 font-medium text-pl-accent hover:underline focus:underline focus:outline-none cursor-pointer ${
            pdfLoading ? "opacity-50 cursor-not-allowed" : ""
          }`}
          aria-label={`Open ${caseNumberLabel} judgment`}
          title={pdfLoading ? "Loading PDF..." : "Open judgment"}
        >
          {pdfLoading ? "Loading..." : caseNumberLabel}
        </button>
      </td>

      <td className="py-2 md:py-3 px-2 align-top">
        <div
          className="text-14 md:text-15 font-medium text-pl-text-primary break-words"
          title={hit.nameofparties}
        >
          {hit.nameofparties}
        </div>
      </td>

      <td className="py-2 md:py-3 px-2 align-top text-right w-[76px] md:w-[120px]">
        {summaryPath && (
          <button
            type="button"
            onClick={handleViewSummary}
            className="text-left md:text-right leading-[14px] md:leading-4 text-13 text-pl-text-tertiary hover:text-pl-accent transition-colors cursor-pointer"
          >
            <span className="block md:inline">View</span>
            <span className="block md:inline md:ml-1 whitespace-nowrap">summary &rarr;</span>
          </button>
        )}
      </td>
    </tr>
  );
};

export default ReportHit;
